import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeModule } from './modules/home/home.module';

const routes: Routes = [{ 
  path: '',     
  loadChildren: () => HomeModule 
},{
  path: 'quem-somos',  
  loadChildren: () => import('src/app/modules/sobre/sobre-module/sobre.module').then(m => m.SobreModule) 
},{
  path: 'cases',  
  loadChildren: () => import('src/app/modules/pages/cases/cases-page/cases-page.module').then(m => m.CasesPageModule) 
},{
  path: 'eventos',
  loadChildren: () => import('src/app/modules/pages/evento/eventos-page/eventos-page.module').then(m => m.EventosPageModule) 
},{
  path: 'eventos/:apelido',
  loadChildren: () => import('src/app/modules/pages/evento/evento-page/evento-page.module').then(m => m.EventoPageModule) 
},{
  path: 'carrinho/pagamento/aprovado',
  loadChildren: () => import('src/app/modules/checkout/checkout-pagamento-aprovado/checkout-pagamento-aprovado.module').then(m => m.CheckoutPagamentoAprovadoModule) 
},{
  path: 'meus-pedidos',
  loadChildren: () => import('src/app/modules/minha-conta/pedidos/pedidos.module').then(m => m.PedidosModule) 
},{
  path: 'contato',  
  loadChildren: () => import('src/app/modules/contato/contato.module').then(m => m.ContatoModule) 
},{    
  path: '**',
  pathMatch: 'full', 
  redirectTo: ''
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
